(ns app.domain.phase-result.model
  (:require [core.db.child-entity :as child]))

(def ^{:arglists '([phase-entity])} get-result
  (child/child-entity-of-type-fn :entity.type/phase-result))

(defn get-published-result
  "Return the phase result unless it is still a draft."
  [phase]
  (let [result (get-result phase)]
    (when-not (= :phase-result.state/draft (:domain/state result))
      result)))
